import React from 'react';
import type { PerformanceStatus } from '../../types/dashboard';
const STYLES: Record<PerformanceStatus, string> = {
  'Above network': 'bg-positive-soft text-positive',
  'On par': 'bg-canvas text-ink-muted',
  'Below network': 'bg-caution-soft text-caution',
  'Priority review': 'bg-negative-soft text-negative',
  Ramping: 'bg-navy-50 text-navy'
};
export function StatusBadge({
  status
}: {
  status: PerformanceStatus;
}) {
  return <span className={`inline-flex items-center whitespace-nowrap rounded px-2 py-0.5 text-[11.5px] font-semibold ${STYLES[status]}`} data-id="element-749" data-mp="26ubggxzoo7bu">
      {status}
    </span>;
}